<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <span class="title_head">Add Transfer</span>
            <div class="row">
              <div class="col-sm-12">
                <div v-if="hasErrors.message != ''" class="alert alert-success">
                  <center>
                    <strong>Success!</strong>{{ hasErrors.message }}
                  </center>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label for="name">From Shop </label>
                  <model-list-select
                    :list="fromshp"
                    option-value="est_shop_id"
                    option-text="est_shop_name"
                    v-model="from_sh"
                    placeholder="From Shop"
                    @input="fromShpSelected()"
                    style="
                      -webkit-text-fill-color: rgb(83, 108, 121) !important;
                      height: 20px !important;
                      border: 1px solid rgb(194, 207, 214);
                      min-height: 35px;
                    "
                  ></model-list-select>
                </div>
                <small class="form-text text-muted"
                  ><strong style="color: red;">{{
                    hasErrors.fromshop
                  }}</strong></small
                >
              </div>

              <div class="col-md-3">
                <div class="form-group">
                  <label for="name">To Shop </label>
                  <model-list-select
                    :list="toshp"
                    option-value="est_shop_id"
                    option-text="est_shop_name"
                    v-model="to_sh"
                    placeholder="To Shop"
                    @input="toShpSelected()"
                    style="
                      -webkit-text-fill-color: rgb(83, 108, 121) !important;
                      height: 20px !important;
                      border: 1px solid rgb(194, 207, 214);
                      min-height: 35px;
                    "
                  ></model-list-select>
                </div>
                <small class="form-text text-muted"
                  ><strong style="color: red;">{{
                    hasErrors.toshop
                  }}</strong></small
                >
              </div>

              <div class="col-md-3">
                <div class="form-group">
                  <label for="name"> Dispatch Date </label><br />
                  <date-picker
                    editable
                    lang="en"
                    v-model="dispatch_DT"
                    @input="dispatchSelected()"
                  ></date-picker>
                </div>
                <small class="form-text text-muted"
                  ><strong style="color: red;">{{
                    hasErrors.dispatch
                  }}</strong></small
                >
              </div>

              <div class="col-md-3">
                <div class="form-group">
                  <label for="name"> Expected to arrive </label><br />
                  <date-picker
                    editable
                    lang="en"
                    v-model="receive_DT"
                    @input="receivedSelected()"
                  ></date-picker>
                </div>
                <small class="form-text text-muted"
                  ><strong style="color: red;">{{
                    hasErrors.received
                  }}</strong></small
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <span class="title_head">Item Details</span>
          </div>
          <div class="card-body" style="padding: 0px !important;">
            <div class="table-responsive-sm">
              <table class="table table-striped" width="100%">
                <thead style="padding: 5px;">
                  <tr>
                    <th class="span2" style="width: 10%; padding-left: 10px;">
                      Product ID
                    </th>
                    <th class="span2" style="width: 45%;">Product Name</th>
                    <th class="span2" style="width: 15%;">Product Qty</th>
                    <th class="span2" style="width: 30%;">Transfer Shop</th>
                  </tr>
                </thead>
                <tbody id="product_table_body">
                  <tr v-for="(row, index) in rows">
                    <td>{{ row.product_id }}</td>
                    <td>
                      <div class="row">
                        <div class="col-sm-10">
                          <model-list-select
                            :list="row.productname"
                            option-value="product_id"
                            option-text="product_name"
                            v-model="row.selectproductrow"
                            placeholder="Search Product Name"
                            @input="onSelect($event, row)"
                            @searchchange="searchprd($event, index, row)"
                            style="
                              -webkit-text-fill-color: rgb(
                                83,
                                108,
                                121
                              ) !important;
                              height: 20px !important;
                              border: 1px solid rgb(194, 207, 214);
                              min-height: 35px;
                            "
                          ></model-list-select>
                        </div>
                        <div class="col-md-2" style="padding-left: 0px;">
                          <a target="_blank" href="#/setup/addupdateproduct"
                            ><button
                              type="button"
                              title=""
                              class="btn btn-pill btn-primary"
                              data-original-title="Add New Product"
                            >
                              <i
                                class="fa fa-plus"
                                style="color: rgb(255, 255, 255);"
                              ></i></button
                          ></a>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-6">
                          <small
                            style="
                              font-size: 14px;
                              color: green;
                              margin-top: 41px;
                            "
                            >Product Unit
                            <span style="color: #000;">{{
                              row.unit_name
                            }}</span></small
                          >
                        </div>
                        <div class="col-sm-6">
                          <small
                            style="
                              font-size: 14px;
                              color: green;
                              margin-top: 41px;
                            "
                            @click="openvariant(row, index)"
                            ><a v-if="row.show == true" style="cursor: pointer;"
                              >Change Variant: {{ row.variantrow }}</a
                            ></small
                          >
                          <small
                            style="
                              font-size: 14px;
                              color: green;
                              margin-top: 41px;
                            "
                          >
                            <a v-if="row.show1 == true"
                              >Variant :{{ row.variantrow }}</a
                            >
                          </small>
                        </div>
                      </div>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="form-control"
                        autocomplete="off"
                        v-model="row.quantity"
                        v-on:change="quantity(row)"
                      />
                      <small
                        style="font-size: 14px; color: green; margin-top: 41px;"
                        >Available Qty
                        <span style="color: red;">{{
                          row.avai_quantity
                        }}</span></small
                      >
                    </td>
                    <td>
                      <input
                        type="text"
                        class="form-control"
                        autocomplete="off"
                        v-model="row.toshp_lbl"
                        disabled
                        style="width: 90%;"
                      />
                      <div
                        style="
                          float: right;
                          font-size: 23px;
                          padding-right: 10px;
                          margin-top: -37px;
                        "
                      >
                        <span
                          ><a
                            style="cursor: pointer;"
                            v-b-tooltip.hover
                            title="Delete"
                            ><i
                              class="fa fa-trash"
                              style="color: red;"
                              v-on:click="removeElement(index)"
                            ></i></a
                        ></span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              style="
                font-size: 15px;
                color: green;
                margin-top: -8px;
                margin-left: 7px;
                margin-bottom: 8px;
              "
            >
              Add New Row :
              <span
                style="cursor: pointer;"
                @click="addRow1"
                class="badge badge-pill badge-info"
                v-b-tooltip.hover
                title="Add New Row"
                >Add</span
              >
            </div>
          </div>
          <div class="row" style="padding: 15px !important;">
            <div class="col-md-12">
              <div class="form-group">
                <label for="name">Note (optional) :</label>
                <textarea
                  rows="2"
                  v-model="note"
                  class="form-control"
                ></textarea>
              </div>
              <small class="form-text text-muted"
                ><strong style="color: red;">{{
                  hasErrors.note
                }}</strong></small
              >
            </div>
          </div>
          <div class="card-footer card-footer">
            <button class="btn btn-primary btn-sm" @click="saveTransfer">
              <i class="fa fa-dot-circle-o"> Save</i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- changes in popup modal -->
    <b-modal
      title="Select Variant"
      size="sm"
      v-model="smallmodal"
      hide-footer
      @ok="smallmodal = false"
    >
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <model-list-select
              :list="variantvalue"
              option-value="variant_id"
              option-text="variant_id"
              v-model="variantdata"
              placeholder="Search Variant Value"
              @input="onSelectvariant($event)"
              style="
                -webkit-text-fill-color: rgb(83, 108, 121) !important;
                height: 20px !important;
                border: 1px solid rgb(194, 207, 214);
                min-height: 35px;
              "
            >
            </model-list-select>
          </div>
        </div>
      </div>
      <!-- <div class="row">
            <div class="col-sm-12">
                <div class="form-group">
                      <button type="submit" class="btn btn-sm btn-primary" @click="savevatiantmodal(indexval)">
                      <i class="fa fa-dot-circle-o"></i> Save</button>
                </div>
            </div>
          </div> -->
    </b-modal>
    <!-- end  -->

    <Spinner v-if="loading"></Spinner>
  </div>
</template>

<script>
import Spinner from "../../spinner.vue";
import DatePicker from "vue2-datepicker";
import company_mgmtVue from '../admin_pages/company_mgmt.vue';
export default {
  name: "shop",
  components: {
    "date-picker": DatePicker,
    Spinner,
  },
  data() {
    return {
      largeModal: false,
      smallmodal: false,
      variantdata: null,
      variantindex: null,
      variantvalue: [],
      fromshp: [],
      toshp: [],
      loading: false,
      rows: [],
      dispatch_DT: "",
      receive_DT: "",
      note: "",
      from_sh: null,
      to_sh: null,
      rows: [],
      hasErrors: {
        message: "",
        fromshop: "",
        toshop: "",
        dispatch: "",
        received: "",
        note: "",
      },
      errorMessage: {
        message: null,
      },
    };
  },
  created() {
    for (var i = 0; i < 1; i++) {
      this.rows.push({
        product_id: "",
        selectedproductid: "",
        productname: [],
        selectproductrow: null,
        unit_id: "",
        unit_name: "",
        variantrow: "n/a",
        show: false,
        show1: false,
        avai_quantity: 0,
        product_name: "",
        quantity: 0,
        est_shop_id_to: "",
        toshp_lbl: "",
        last_purprice_bft: 0,
        last_purprice_aft: 0,
        exp_sellprice_bft: 0,
        inclusive1: false,
      });
    }
    this.getShop();
    this.shopuser();
  },
  methods: {
    // chkFromShop(){
    //   console.log(this.to_sh)
    //   if(this.to_sh !== null){
    //     console.log(this.to_sh)
    //   }
    // },

    shopuser() {
      var _this = this;
      this.$http
        .get("/api/shopusers")
        .then(function (response) {})
        .catch(function (error) {
          if (error.response.status === 401) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
          if (
            error.response.data.error.message ===
            "Cannot read property 'cmpname' of null"
          ) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
        });
    },
    clear_all_rows() {
      if (this.rows.length > 0) {
        for (var i = 0; i < this.rows.length; i++) {
          (this.rows[i]["product_id"] = ""),
            (this.rows[i]["productname"] = []),
            (this.rows[i]["selectproductrow"] = null),
            (this.rows[i]["unit_id"] = ""),
            (this.rows[i]["unit_name"] = ""),
            (this.rows[i]["avai_quantity"] = 0),
            (this.rows[i]["product_name"] = ""),
            (this.rows[i]["quantity"] = 0),
            (this.rows[i]["est_shop_id_to"] = "");
        }
      }
    },
    dispatchSelected() {
      this.hasErrors.dispatch = "";
    },
    receivedSelected() {
      this.hasErrors.received = "";
    },
    fromShpSelected() {
      this.hasErrors.fromshop = "";
      this.clear_all_rows();
    },
    toShpSelected() {
      this.hasErrors.toshop = "";
      if (this.rows.length > 0) {
        for (var i = 0; i < this.rows.length; i++) {
          this.rows[i]["toshp_lbl"] = this.to_sh.est_shop_name;
        }
      }
    },
    quantity(row) {
      var num = /^[0-9]{1,10}$/;
      var price = /^\d{1,12}(\.\d{1,6})?$/;
      if (parseFloat(row.quantity) > parseFloat(row.avai_quantity)) {
        row.quantity = 0;
        alert(
          "Transfer quantity should not be greater than " + row.avai_quantity
        );
      } else if (price.test(parseFloat(row.quantity)) == false) {
        row.quantity = 0;
        alert("Invalid Quantity Entered");
      }
    },
    openvariant(row, index) {
      this.variantindex = index;
      this.variantvalue = row.selectedproductid;
      this.smallmodal = true;
    },
    onSelectvariant(option) {
      this.rows[this.variantindex]["product_id"] = option.product_id;
      this.rows[this.variantindex]["unit_id"] = option.unit_id;
      this.rows[this.variantindex]["unit_name"] = option.unit_name;
      this.rows[this.variantindex]["avai_quantity"] = option.quantity;
      this.rows[this.variantindex]["variantrow"] = option.variant_id;
      this.rows[this.variantindex]["last_purprice_bft"] =
        option.last_purprice_bft;
      this.rows[this.variantindex]["last_purprice_aft"] =
        option.last_purprice_aft;
      this.rows[this.variantindex]["exp_sellprice_bft"] =
        option.exp_sellprice_bft;
      this.smallmodal = false;
    },
    onSelect(option, row) {
      var _this = this;
      row.product_id = "";
      row.unit_id = "";
      row.unit_name = "";
      row.avai_quantity = 0;
      row.show = false;
      row.variantrow = "n/a";
      this.$http
        .get(
          "/api/estshopinventories/getinventory?filter[where][product_id]=" +
            option.product_id +
            "&filter[where][est_shop_id]=" +
            option.est_shop_id
        )
        .then(function (response) {
          if (response.data[0].tax_inclusive == true) {
            row.inclusive1 = true;
          }
          if (response.data.length > 1) {
           
            row.product_id = response.data[0].product_id;
            row.unit_id = response.data[0].unit_id;
            row.unit_name = response.data[0].unit_name;
            row.avai_quantity = response.data[0].quantity;
            row.variantrow = response.data[0].variant_id;
            row.selectedproductid = response.data;
            row.last_purprice_bft = response.data[0].last_purprice_bft;
            row.last_purprice_aft = response.data[0].last_purprice_aft;
            row.exp_sellprice_bft = response.data[0].exp_sellprice_bft;
            row.show = true;
            row.show1 = false;
          } else {
            if (response.data[0].variant_id == "n/a") {
              row.product_id = response.data[0].product_id;
              row.unit_id = response.data[0].unit_id;
              row.unit_name = response.data[0].unit_name;
              row.avai_quantity = response.data[0].quantity;
              row.show = false;
              row.show1 = true;
              row.variantrow = "n/a";
              row.last_purprice_bft = response.data[0].last_purprice_bft;
              row.last_purprice_aft = response.data[0].last_purprice_aft;
              row.exp_sellprice_bft = response.data[0].exp_sellprice_bft;
            } else {
              row.product_id = response.data[0].product_id;
              row.unit_id = response.data[0].unit_id;
              row.unit_name = response.data[0].unit_name;
              row.avai_quantity = response.data[0].quantity;
              row.show = false;
              row.show1 = true;
              row.variantrow = response.data[0].variant_id;
              row.last_purprice_bft = response.data[0].last_purprice_bft;
              row.last_purprice_aft = response.data[0].last_purprice_aft;
              row.exp_sellprice_bft = response.data[0].exp_sellprice_bft;
            }
          }
        })
        .catch(function (error) {});
    },

    row_reset(row) {
      row.product_id = "";
      row.unit_id = "";
      row.unit_name = "";
      row.avai_quantity = 0;
      (row.selectproductrow = null),
        (row.product_name = ""),
        (row.quantity = 0),
        (row.est_shop_id_to = ""),
        (row.toshp_lbl = "");
    },
    searchprd(searchText, index, row) {
      if (this.from_sh == null || this.from_sh.est_shop_id == undefined) {
        this.hasErrors.fromshop = "Please Select Transfer From Shop";
      } else {
        this.hasErrors.fromshop = "";
        var data = [];
        data = data + "&filter[where][product_name]=%" + searchText + "%";
        data = data + "&filter[where][shopid]=" + this.from_sh.est_shop_id;
        var _this = this;
        this.$http
          .get("/api/stocktransfers/shop_products?" + data)
          .then(function (response) {
            row.productname = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    getShop() {
      var _this = this;
      this.$http
        .get("/api/shopestablishments")
        .then(function (response) {
          _this.fromshp = response.data;
          _this.toshp = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    addRow1() {
      if (this.to_sh == null || this.to_sh == undefined) {
        var toshp_val = null;
      } else {
        var toshp_val = this.to_sh.est_shop_name;
      }
      this.rows.push({
        product_id: "",
        selectedproductid: "",
        productname: [],
        selectproductrow: null,
        unit_id: "",
        unit_name: "",
        variantrow: "n/a",
        show: false,
        show1: false,
        avai_quantity: 0,
        product_name: "",
        quantity: 0,
        est_shop_id_to: "",
        toshp_lbl: toshp_val,
        last_purprice_bft: 0,
        last_purprice_aft: 0,
        exp_sellprice_bft: 0,
        inclusive1: false,
      });
    },
    validation() {
      var success = 0;
      this.hasErrors.message = "";
      this.hasErrors.dispatch = "";
      this.hasErrors.received = "";
      this.hasErrors.fromshop = "";
      this.hasErrors.toshop = "";
      this.hasErrors.note = "";
      if (this.dispatch_DT == "") {
        success = 1;
        this.hasErrors.dispatch = "Required";
      }
      if (this.receive_DT == "") {
        success = 1;
        this.hasErrors.received = "Required";
      }
      if (this.from_sh == null || this.from_sh.est_shop_id == undefined) {
        success = 1;
        this.hasErrors.fromshop = "Required";
      }
      if (this.from_sh === this.to_sh) {
        success = 1;
        this.hasErrors.toshop = "To Shop and From Shop are Same.";
      }
      if (this.to_sh == null || this.to_sh.est_shop_id == undefined) {
        success = 1;
        this.hasErrors.toshop = "Required";
      }
      if (this.note.length > 255) {
        success = 1;
        this.hasErrors.note = "Note cannot be greater than 255 characters";
      }
      if (this.dispatch_DT !== "" && this.receive_DT !== "") {
        if (Date.parse(this.receive_DT) < Date.parse(this.dispatch_DT)) {
          success = 1;
          this.hasErrors.received =
            "Must be greater than or equal to dispatch date";
        }
      }

      for (var j = this.rows.length - 1; j >= 0; j--) {
        if (this.rows[j].selectproductrow == null) {
          this.rows.splice(j, 1);
        }
      }

      if (this.rows.length == 0) {
        alert("Transfer Will Not Be Saved");
        success = 1;
      }

      return success;
    },
    saveTransfer() {
      var success = this.validation();
      if (success == 0) {
        this.loading = true;
        var data = {};
        // var dispatch_DT = this.dispatch_DT
        // var receive_DT = this.receive_DT
        var myDate1 = new Date(this.dispatch_DT);
        var myDate2 = new Date(this.receive_DT);
        var num = /^[0-9]{1}$/;
        var year1 = myDate1.getFullYear();
        var month1 = myDate1.getMonth() + 1;
        var daycon = myDate1.getDate();
        if (num.test(month1) == true) {
          var month1 = "0" + month1;
        } else {
          var month1 = month1;
        }
        if (num.test(daycon) == true) {
          var day1 = "0" + daycon;
        } else {
          var day1 = daycon;
        }

        var year = myDate2.getFullYear();
        var month = myDate2.getMonth() + 1;
        var day = myDate2.getDate();
        if (num.test(month) == true) {
          var month = "0" + month;
        } else {
          var month = month;
        }
        if (num.test(day) == true) {
          var day = "0" + day;
        } else {
          var day = day;
        }

        var receive_DT = year + "-" + month + "-" + day;
        var dispatch_DT = year1 + "-" + month1 + "-" + day1;
        // dispatch_DT = myDate1.toLocaleDateString()
        // receive_DT = myDate2.toLocaleDateString()

        data.est_shop_id_from = this.from_sh.est_shop_id;
        data.est_shop_id_to = this.to_sh.est_shop_id;
        data.dispatch_datetime = dispatch_DT;
        data.receive_datetime = receive_DT;
        data.product_items = this.rows;
        data.note = this.note;

        var _this = this;

        this.$http
          .post("/api/stocktransfers/save_transfer", data)
          .then(function (response) {
            _this.loading = false;
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            _this.hasErrors.message = " Transfer Added Successfully";
            setTimeout(function () {
              _this.hasErrors.message = "";
            }, 2000);
            _this.reset();
          })
          .catch(function (error) {
            _this.loading = false;
          });
      }
    },
    reset() {
      this.from_sh = null;
      this.to_sh = null;
      this.dispatch_DT = "";
      this.receive_DT = "";
      this.note = "";

      for (var j = this.rows.length - 1; j >= 0; j--) {
        this.rows.splice(j, 1);
      }

      for (var i = 0; i < 1; i++) {
        this.rows.push({
          product_id: "",
          selectedproductid: "",
          productname: [],
          selectproductrow: null,
          unit_id: "",
          unit_name: "",
          variantrow: "n/a",
          show: false,
          show1: false,
          avai_quantity: 0,
          product_name: "",
          quantity: 0,
          est_shop_id_to: "",
          toshp_lbl: "",
          last_purprice_bft: 0,
          last_purprice_aft: 0,
          exp_sellprice_bft: 0,
          inclusive1: false,
        });
      }
    },
    removeElement: function (index) {
      this.rows.splice(index, 1);
    },
  },
};
</script>

<style type="text/css">
.table th,
.table td {
  padding: 0.25rem;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/views/transfer/Addtransfer.vue